export const supportedLocales = ['en', 'ja', 'zh-TW', 'ko'];
/** Active Vendor categories (ADR-030). HOTEL and RESTAURANT are rejected. */
export const vendorCategories = [
    'TRANSPORTATION',
    'GUIDE',
    'ACTIVITY',
    'TICKET',
    'OTHER',
];
/** Active generic Service categories (ADR-030). */
export const serviceCategories = [
    'TRANSPORTATION',
    'GUIDE',
    'ACTIVITY',
    'TICKET',
    'OTHER',
];
export const serviceCategoryChargingUnits = {
    TRANSPORTATION: 'PER_VEHICLE',
    GUIDE: 'PER_SERVICE',
    ACTIVITY: 'PER_PERSON',
    TICKET: 'PER_PERSON',
    OTHER: 'PER_SERVICE',
};
export const queryMainStatuses = ['LIVE', 'HOLD', 'CONVERTED', 'COLD'];
export const queryLifecycleStatuses = [
    'ACTIVE',
    'LOST',
    'CANCELLED',
    'CLOSED',
];
export const queryWorkflowStages = [
    'RESERVATION_ACTIVE',
    'QUOTATION_SENT',
    'PRICED_ITINERARY_SENT',
    'AGENT_ACCEPTED',
    'READY_TO_INVOICE',
    'AWAITING_FINANCE_GATE_1',
    'OPERATIONS_ACTIVE',
    'AWAITING_FINANCE_GATE_2',
    'QC_ACTIVE',
    'TRAVEL_PACK_READY',
    'SUPPORT_ACTIVE',
    'TRIP_COMPLETED',
    'AWAITING_DEPARTMENT_CLOSURE',
    'COLD',
    'CLOSED',
];
export const queryFollowUpReminderStatuses = [
    'PENDING',
    'COMPLETED',
];
export const queryQueueKeys = [
    'PENDING_EMAILS',
    'PENDING_ACKNOWLEDGEMENT',
    'LIVE',
    'COLD',
    'PENDING_AVAILABILITY',
    'READY_TO_INVOICE',
    'PENDING_BOOKINGS',
];
export const queryWorkspaceTabIds = [
    'overview',
    'communication',
    'itinerary',
    'quotations',
    'travellers',
    'finance',
    'operations',
    'qc',
    'travel-pack',
    'support',
    'activity',
    'costing',
];
export const itineraryEvidencePurposes = [
    'EXTERNAL_DELIVERY',
    'AGENT_DECISION',
];
export const pricePresentations = [
    'TOTAL',
    'PER_PERSON',
    'SERVICE_LEVEL',
];
export const queryWorkspaceCommands = ['mark_lost', 'reopen_cold'];
export const mailboxTypes = ['CENTRAL', 'RESERVATION_EXECUTIVE'];
export const queryIntakeMainStatuses = ['NEW', 'ASSIGNED'];
export const queryAcknowledgementStatuses = [
    'PENDING',
    'QUEUED',
    'SENDING',
    'SENT',
    'FAILED',
];
export const emailCommunicationTypes = [
    'GENERAL_REPLY',
    'QUERY_ACKNOWLEDGEMENT',
];
export const markupCategories = [
    'HOTEL',
    'GUIDE',
    'TRANSPORTATION',
    'TICKET',
    'ACTIVITY',
    'OTHER',
];
export const markupClasses = ['HOTEL', 'NON_HOTEL'];
//# sourceMappingURL=index.js.map